<script>
    /*
    	ContinueButton.svelte
    */

    import { onMount } from 'svelte';

    // TCARE components

    // SMUI components

    export let nextSectionId;
    export let setExpanded;
    
    onMount(() => {
    })

</script>

<style>

    /* TODO: use a SMUI Button here? */
    .continue-button button {
        width: 125px;
        height: 35px;
        margin: 0px;
        font-size: 14px;
        line-height: 16px;
        letter-spacing: 1px;
        color: white;
        background-color: var(--tcui-aqua);
        border-radius: 16px;
        border: none;
    }

    .continue-button button:hover {
        background-color: var(--tcui-secondary);
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="continue-button">
    <button on:click={() => setExpanded(nextSectionId)}>
        Continue
    </button>
</div>
